var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-child"},[_c('div',{staticClass:"avatar"},[_c('child-icon')],1),_c('div',{staticClass:"nickname"},[_vm._v(_vm._s(_vm.child.nickname))]),_c('div',{staticClass:"tag"},[_vm._v("儿童")]),_c('ghost-btn',{attrs:{"copy":_vm.$t('btn.delete')},on:{"clicked":_vm.onRemove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }